import { compose, equals, identity, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { LOADER_REDUCER_NAME, STATUS } from '../constants';

const getReducer = createSelector(identity, propOr({}, LOADER_REDUCER_NAME));

export const getIsPostInitLoaderActive = createSelector(
	getReducer,
	compose(equals(STATUS.active), propOr(STATUS.inactive, 'status')),
);
